module.exports = __webpack_public_path__ + "images/buttons/no_plus_button.gif";